<div class="main-content">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon">
              <i class="material-icons">key</i>
            </div>
            <h4 class="card-title">Forgot Password</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="row" *ngIf="step === 1">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="username">Email</label>
                    <div class="d-flex">
                      <input
                        type="text"
                        class="form-control"
                        id="username"
                        formControlName="username"
                        placeholder="Enter the email address associated with this account"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('username')"
                      >
                        The email is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="step === 2">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="temporaryPassword"
                      >Temporary password</label
                    >
                    <div class="d-flex">
                      <input
                        type="text"
                        class="form-control"
                        id="temporaryPassword"
                        formControlName="temporaryPassword"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('temporaryPassword')"
                      >
                        Temporary password is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="step === 2">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="newPassword"
                      >New password</label
                    >
                    <div class="d-flex">
                      <input
                      [type]="showPassword ? 'text' : 'password'"
                        class="form-control"
                        id="newPassword"
                        formControlName="newPassword"
                      />
                      <div class="input-group-append">
                        <span
                          class="input-group-text"
                          style="cursor: pointer"
                          (click)="togglePasswordVisibility()"
                        >
                          <i class="material-icons">{{
                            showPassword ? "visibility_off" : "visibility"
                          }}</i>
                        </span>
                      </div>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('newPassword')"
                      >
                        New password is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="step === 2">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="confirmNewPassword"
                      >Confirm new password</label
                    >
                    <div class="d-flex">
                      <input
                      [type]="showPasswordTwo ? 'text' : 'password'"
                        class="form-control"
                        id="confirmNewPassword"
                        formControlName="confirmNewPassword"
                      />
                      <div class="input-group-append">
                        <span
                          class="input-group-text"
                          style="cursor: pointer"
                          (click)="togglePasswordVisibilityTwo()"
                        >
                          <i class="material-icons">{{
                            showPasswordTwo ? "visibility_off" : "visibility"
                          }}</i>
                        </span>
                      </div>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('confirmNewPassword')"
                      >
                        Confirm New Password is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row text-center">
                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-dark pull-right btn-send"
                    [disabled]="form.invalid"
                  >
                    Send
                  </button>
                </div>
              </div>

              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
